<script setup lang="ts">
import { useOfferTimer } from '@/composables/offer/useOfferTimer';
import { useWordEnding } from '@/composables/useWordEnding';

const props = defineProps<{
  expiresAt: string;
}>();

const { days, hours, minutes, seconds } = useOfferTimer(props.expiresAt);
</script>

<template>
  <div class="mt-6 flex gap-3">
    <div class="timer">
      {{ days }}<span>{{ useWordEnding(days, ['день', 'дня', 'дней']) }}</span>
    </div>
    <div class="timer">
      {{ hours }}<span>{{ useWordEnding(days, ['час', 'часа', 'часов']) }}</span>
    </div>
    <div class="timer">
      {{ minutes }}<span>{{ useWordEnding(minutes, ['минута', 'минуты', 'минут']) }}</span>
    </div>
    <div class="timer">
      {{ seconds }}<span>{{ useWordEnding(seconds, ['секунда', 'секунды', 'секунд']) }}</span>
    </div>
  </div>
</template>

<style scoped>
@reference 'tailwindcss';
.timer {
  @apply min-w-[70px] rounded-lg bg-white/10 px-4 py-3 text-center text-lg font-semibold backdrop-blur;
}

.timer span {
  @apply block text-xs opacity-70;
}
</style>
